module.exports = __webpack_public_path__ + "img/microgaming-white.8b458087.svg";